import { useColorPalette } from '../hooks/useColorPalette';

export default function Hr() {
    const palette = useColorPalette();
    
    return (
        <div 
            className="w-full h-[1px]" 
            style={{ backgroundColor: palette.accent || '#f5f5f5' }}
        ></div>
    );
}